<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'

   export default {
      page: {
         title: "Edit Schedule or Mark Leave",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Edit Schedule or Mark Leave",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },                
               
               {
                  text: "Edit Schedule or Mark Leave",
                  active: true,
               },                     
            ],
            selected: ['video','clinic','home'],
            schedule_date: '',
            schedule_from_date: '',
            eqDate:false,
            dfDate:false,
            startDate:'',
            endDate:'',
            sameDate:'',
            fee:'',
            leave_status: null,
            editschedule: '',
            video_status: 'accepted',
            clinic_status: 'not_accepted',
            home_status: 'not_accepted',
            title_modal: 'Add Session',
            home_schedules:[],
            video_schedules:[],
            clinic_schedules:[],
            video_schedule_status:'',
            home_schedule_status:'',
            video_consultation: [
                     
                     {
                        start: '',
                        end: '',
                        duration_id: '',
                        duration: '',
                        clinic_id: '',
                        clinic_name: '',
                        reserved: ''
                     }
            ],
            

            home_consultation: [
                     {
                        start: '',
                        end: '',
                        duration_id: '',
                        duration: '',
                        clinic_id: '',
                        clinic_name: '',
                        reserved: ''
                     }
            ],

            clinic_consultation: [
                     {
                        start: '',
                        end: '',
                        duration_id: '',
                        duration: '',
                        clinic_id: '',
                        clinic_name: '',
                        reserved: '',
                        consultation_fee: '',
                     },

            ],
            
            duration:'',
            set_time:'',
            hour:'',
            minutes:'',
            time_name:'',
            deactivate: false,
            start: '',
            end: '',
            day: null,
            type: '',
            duration_id: '',
            clinic_id: '',
            clinic_name: '',
            reserved: '',
            session_id: '',
            edit_id: '',
            consultation_type: '',
            booked_slots: '',
            form_type: '',           
            pin_no: "",
            curr_session: {},
            curr_schedule: {},
            curr_type: "",
            durations: [
               { value: '', text: 'Select' },
               { value: 1, text: '01 minutes' },
               { value: 2, text: '02 minutes' },
               { value: 3, text: '03 minutes' },
               { value: 4, text: '04 minutes' },
               { value: 5, text: '05 minutes' },
               { value: 10, text: '10 minutes' },
               { value: 15, text: '15 minutes' },
            ],

            clinics: [],
           

            errors: {},

            edit: false,
            index: null,


         };
      },
      mounted() {
         //alert(this.type);
      },

      watch: {
         start() {
         this.start = this.start.split(":").slice(0, 2).join(":");
         },
         end() {
         this.end = this.end.split(":").slice(0, 2).join(":");
         },
         duration() {
         this.duration = this.duration.split(":").slice(0, 2).join(":");
         },
      },

      created() {
         this.fetchClinics();
      },
      computed: {
         filteredClinicSchedules() {
            return this.clinic_schedules.map(schedule => {
                  const filteredSchedules = schedule.schedules.filter(s => s.show_status);
                  return {
                     ...schedule,
                     schedules: filteredSchedules
                  };
            }).filter(schedule => schedule.schedules.length > 0);
         }
      },
      methods: {


         fetchClinics() {
              
            let url = "api/admin/leave/getClinicsFee?doctor_id=" + this.$route.params.id;
            this.getToken();
              this.$axios
                 .get(url, { headers: { Authorization: "Bearer " + this.token } })
                 .then((res) => {
                    var responseData = res.data.data;
                    console.log(responseData);
                    this.clinics = responseData.clinics;
                 })
                 .catch((err) => console.log(err));
         },
  
         fetchData() {
            if(this.schedule_date && this.schedule_from_date){
               if (this.schedule_from_date === this.schedule_date) {
               this.sameDate = this.schedule_from_date;
               } 

               let url = "api/admin/leave/getSchedules?doctor_id=" + this.$route.params.id+ "&from_date=" + this.schedule_from_date + "&to_date=" + this.schedule_date;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.clinic_schedules = responseData.clinic_schedule;
                     this.video_schedules = responseData.video_schedule;
                     this.home_schedules = responseData.home_schedule;
                     this.video_schedule_status = responseData.video_schedule_status;
                     this.home_schedule_status = responseData.home_schedule_status;
                     // if(this.video_schedules.schedules.length) {
                     //    this.setConsultations('video');
                     // }

                  })
                  .catch((err) => console.log(err));
            }
         },
         
         getToken() {
         if (localStorage.getItem('sigohealth_admin')) {
            var sigohealth_admin =  JSON.parse(localStorage.getItem('sigohealth_admin'));
            if(sigohealth_admin.token) {
               this.token = sigohealth_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },
         addSession() {
            if(this.edit) {

               // if(this.type == 'video') {
               //    console.log('ljdk', this.index);

               //    this.video_consultation[this.index].start = this.start;
               //    this.video_consultation[this.index].end = this.end;
               //    this.video_consultation[this.index].duration_id = this.duration_id;
               //    this.video_consultation[this.index].duration = this.duration;
               //    this.video_consultation[this.index].clinic_id = this.clinic_id;
               //    this.video_consultation[this.index].clinic_name = this.clinic_name;
               //    this.video_consultation[this.index].reserved = this.reserved;

                 
               // } else if(this.type == 'home') {
                 
               //    this.home_consultation[this.index].start = this.start;
               //    this.home_consultation[this.index].end = this.end;
               //    this.home_consultation[this.index].duration_id = this.duration_id;
               //    this.home_consultation[this.index].duration = this.duration;
               //    this.home_consultation[this.index].clinic_id = this.clinic_id;
               //    this.home_consultation[this.index].clinic_name = this.clinic_name;
               //    this.home_consultation[this.index].reserved = this.reserved;
                  
               // } else if(this.type == 'clinic') {
               //    console.log(this.index);

               //    this.clinic_consultation[this.index].start = this.start;
               //    this.clinic_consultation[this.index].end = this.end;
               //    this.clinic_consultation[this.index].duration_id = this.duration_id;
               //    this.clinic_consultation[this.index].duration = this.duration;
               //    this.clinic_consultation[this.index].clinic_id = this.clinic_id;
               //    this.clinic_consultation[this.index].clinic_name = this.clinic_name;
               //    this.clinic_consultation[this.index].reserved = this.reserved;
               // }
               this.editConsultationSession();

            } else {
            
               if(this.type == 'video') {
                  
                  this.video_consultation.push({start: this.start, end: this.end, duration_id: this.duration_id, clinic_id: this.clinic_id, clinic_name: this.clinic_name, reserved: this.reserved});
                 
               } else if(this.type == 'home') {
                 
                  this.home_consultation.push({start: this.start, end: this.end, duration_id: this.duration_id, clinic_id: this.clinic_id, clinic_name: this.clinic_name, reserved: this.reserved});
                  
               } else if(this.type == 'clinic') {
                  
                  this.clinic_consultation.push({start: this.start, end: this.end, duration_id: this.duration_id, clinic_id: this.clinic_id, clinic_name: this.clinic_name, reserved: this.reserved});
               }
               this.addConsultationSession();
            }
            this.clearSession();
            console.log(this.clinic_consultation);
            this.editschedule =1;
            this.leave_status ='';
            this.$refs['session-modal'].hide();

            
         },
         setTime(){
            this.set_time = this.duration;
            this.hour = this.set_time.split(':')[0];
            this.minutes = this.set_time.split(':')[1];
            this.time_name = this.hour+' Hour '+ this.minutes +' minutes ';
         },
         confirmSchedule() {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want confirm this schedule?', {
                  title: 'Add schedule?',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value =>{
                  this.deactivate = value
                  console.log(value);
                  if(this.deactivate){
                  this.editschedule =1;
                  this.leave_status ='';
                  this.$refs['session-modal'].hide();
                  this.addSession();
                  }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         confirmLeave() {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want mark as leave?', {
                  title: 'Mark Leave?',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value =>{
                  this.deactivate = value
                  console.log(value);
                  if(this.deactivate){
                     this.updateLeaveStatus();
                  }
               })
               .catch(err => {
                  console.log(err);
               })
         },

         
         updateLeaveStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/leave/markLeave2?doctor_id=" + this.$route.params.id+ "&from_date=" + this.schedule_from_date + "&to_date=" + this.schedule_date;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchData(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },



         addConsultationSession(){
            if(this.type === 'clinic'){
               this.consultation_type = 3;
            }else if(this.type === 'home'){
               this.consultation_type = 2;
            }else{
               this.consultation_type = 1;
            }

         let existingSchedules = [];
         if (this.type === 'clinic' && Array.isArray(this.clinic_schedules)) {
            existingSchedules = this.clinic_schedules
                  .filter(schedule => schedule.date === this.schedule_from_date)
                  .flatMap(schedule => 
                     Array.isArray(schedule.schedules) ? schedule.schedules.flatMap(sch => 
                        Array.isArray(sch.sessions) ? sch.sessions : []
                     ) : []
                  );
         } else if (this.type === 'home' && Array.isArray(this.home_schedules)) {
            existingSchedules = this.home_schedules
                  .filter(schedule => schedule.date === this.schedule_from_date)
                  .flatMap(schedule => 
                     Array.isArray(schedule.schedules) ? schedule.schedules.flatMap(sch => 
                        Array.isArray(sch.sessions) ? sch.sessions : []
                     ) : []
                  );
         } else if (this.type === 'video' && Array.isArray(this.video_schedules)) {
            existingSchedules = this.video_schedules
                  .filter(schedule => schedule.date === this.schedule_from_date)
                  .flatMap(schedule => 
                     Array.isArray(schedule.schedules) ? schedule.schedules.flatMap(sch => 
                        Array.isArray(sch.sessions) ? sch.sessions : []
                     ) : []
                  );
         }

         if (existingSchedules.length > 0) {
            let newStart = new Date(`${this.schedule_from_date}T${this.start}`);
            let newEnd = new Date(`${this.schedule_from_date}T${this.end}`);

            let conflict = existingSchedules.some(session => {
                  let existingStart = new Date(`${this.schedule_from_date}T${session.start_time}`);
                  let existingEnd = new Date(`${this.schedule_from_date}T${session.end_time}`);

                  return (
                     (newStart >= existingStart && newStart < existingEnd) || 
                     (newEnd > existingStart && newEnd <= existingEnd) || 
                     (newStart <= existingStart && newEnd >= existingEnd)
                  );
            });

            if (conflict) {
                  this.$swal("", "Time slot is already booked. Please select a different time.", "error");
                  return;
            } else {
                  console.log("No conflict detected, proceeding to add the session.");
            }
         } else {
            console.log("No existing schedules found for the selected date.");
         }

         let formData = new FormData();
         formData.append("start", this.start); 
         formData.append("end", this.end); 
         formData.append("duration", this.duration);  
         formData.append("doctor_id", this.$route.params.id); 
         formData.append("consultation_type", this.consultation_type);
         formData.append("from_date", this.schedule_from_date); 
         formData.append("to_date", this.schedule_date);
         formData.append("token_type", this.reserved); 


         if (this.type == 'video') {
            this.type = 1;
         } else if (this.type == 'home') {
            this.type = 2;
         } else if (this.type == 'clinic') {

            this.type = 3;

            formData.append("consultation_fee", this.fee);  
            formData.append("clinic_id", this.clinic_id);
 
         }

         
         let url = "api/admin/leave/addSession2";

         this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            this.$axios
               .post(url, formData, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchData(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });

         },

         checkDuration() {

            let startingTime = moment(this.start, 'HH:mm');
            let endingTime = moment(this.end, 'HH:mm');

            let schedule_duration = moment.duration(endingTime.diff(startingTime)).asMinutes();
            let reserved_duration = moment.duration(this.duration).asMinutes();

            if (reserved_duration > schedule_duration) {
               this.$swal("", "Consultation duration is greater than slot duration!", "error");
            } else {
               this.sessionCheck();
            }
            console.log(startingTime);
            console.log(endingTime);
            console.log(this.start);
            console.log(this.end);
            console.log(this.clinic_schedules);
            console.log(this.home_schedules);
            console.log(this.clinic_schedules);

         },

         sessionCheck() {
            this.getToken();          
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            var c_type = 0;

            if (this.type == 'video') {
               c_type = 1;
            } else if (this.type == 'home') {
               c_type = 2;
            } else if (this.type == 'clinic') {
               c_type = 3;
            }

            // Use c_type somewhere in the code
            console.log(c_type); // Example usage

            let formData = new FormData();
            formData.append("start_time", this.start); 
            formData.append("end_time", this.end); 
            formData.append("duration", this.duration); 
            formData.append("type", c_type); 
            if(c_type == '3'){
               formData.append("clinic_id", this.clinic_id); 
               formData.append("fee", this.fee); 
               formData.append("reserved", this.reserved); 
            }

            let url = "api/admin/doctors/schedules/sessionCheck"; 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  console.log(response);
                  if (response.data.status) {
                     // this.confirmSchedule();
                     this.checkConflict();

                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false)); 
         },

         checkConflict() {
            this.getToken();          
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            
            if(this.edit) {
               let formData = new FormData();
               formData.append("doctor_id", this.$route.params.id); 
               formData.append("date", this.schedule_from_date); 
               formData.append("start", this.start); 
               formData.append("end", this.end); 
               formData.append("session_id", this.session_id);
               if(this.edit_id){
                  formData.append("edit_id", this.edit_id); 
               }else{
                  formData.append("edit_id", ''); 
               } 

               let url = "api/admin/leave/checkSession"; 
               this.$axios
               .post(url, formData, config)
               .then((response) => {
                     console.log(response);
                     if (response.data.status) {
                        this.confirmSchedule();

                     } else {
                        this.$swal("", response.data.message, "error");
                     }
               })
               .catch((error) => {
                     if (error.response) {
                        console.log(error.response);
                        if(error.response.status == 400) {
                           this.$swal("", error.response.data.message, "error");
                        } else {
                           if (error.response.data.message) {
                              this.errors = error.response.data.message;
                              //console.log(this.errors);
                              this.$swal("", "Something went wrong", "error");
                           } else {
                              this.$swal("", "Something went wrong", "error");
                           }
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
               })
               .finally(() => (this.loading = false)); 
            } else{
               let formData = new FormData();
               formData.append("doctor_id", this.$route.params.id); 
               formData.append("from_date", this.schedule_from_date); 
               formData.append("to_date", this.schedule_date);    
               formData.append("start", this.start); 
               formData.append("end", this.end); 

               let url = "api/admin/leave/checkSessionWithRange"; 
               this.$axios
               .post(url, formData, config)
               .then((response) => {
                     console.log(response);
                     if (response.data.status) {
                        this.confirmSchedule();

                     } else {
                        this.$swal("", response.data.message, "error");
                     }
               })
               .catch((error) => {
                     if (error.response) {
                        console.log(error.response);
                        if(error.response.status == 400) {
                           this.$swal("", error.response.data.message, "error");
                        } else {
                           if (error.response.data.message) {
                              this.errors = error.response.data.message;
                              //console.log(this.errors);
                              this.$swal("", "Something went wrong", "error");
                           } else {
                              this.$swal("", "Something went wrong", "error");
                           }
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
               })
               .finally(() => (this.loading = false)); 
            }
         },

         
         editConsultationSession(){

            if (this.type === 'clinic') {
               this.consultation_type = 3;
            } else if (this.type === 'home') {
               this.consultation_type = 2;
            } else {
               this.consultation_type = 1;
            }

            let existingSchedules = [];
            if (this.type === 'clinic' && Array.isArray(this.clinic_schedules)) {
               existingSchedules = this.clinic_schedules
                     .filter(schedule => schedule.date === this.schedule_from_date)
                     .flatMap(schedule => 
                        Array.isArray(schedule.schedules) ? schedule.schedules.flatMap(sch => 
                           Array.isArray(sch.sessions) ? sch.sessions : []
                        ) : []
                     );
            } else if (this.type === 'home' && Array.isArray(this.home_schedules)) {
               existingSchedules = this.home_schedules
                     .filter(schedule => schedule.date === this.schedule_from_date)
                     .flatMap(schedule => 
                        Array.isArray(schedule.schedules) ? schedule.schedules.flatMap(sch => 
                           Array.isArray(sch.sessions) ? sch.sessions : []
                        ) : []
                     );
            } else if (this.type === 'video' && Array.isArray(this.video_schedules)) {
               existingSchedules = this.video_schedules
                     .filter(schedule => schedule.date === this.schedule_from_date)
                     .flatMap(schedule => 
                        Array.isArray(schedule.schedules) ? schedule.schedules.flatMap(sch => 
                           Array.isArray(sch.sessions) ? sch.sessions : []
                        ) : []
                     );
            }

            if (existingSchedules.length > 0) {
               let newStart = new Date(`${this.schedule_from_date}T${this.start}`);
               let newEnd = new Date(`${this.schedule_from_date}T${this.end}`);

               let conflict = existingSchedules.some(session => {
                     let existingStart = new Date(`${this.schedule_from_date}T${session.start_time}`);
                     let existingEnd = new Date(`${this.schedule_from_date}T${session.end_time}`);
                     console.log(existingStart);
                     console.log(existingEnd);
                     console.log(newStart);
                     console.log(newEnd);

                     // return (
                     //    (newStart >= existingStart && newStart < existingEnd) || 
                     //    (newEnd > existingStart && newEnd <= existingEnd) || 
                     //    (newStart <= existingStart && newEnd >= existingEnd) &&
                     //    (this.session_id !== session.doctor_session_id) 
                     // );
               });

               if (conflict) {
                     this.$swal("", "Time slot is already added. Please select a different time.", "error");
                     return;
               } else {
                     console.log("No conflict detected, proceeding to edit the session.");
               }
            } else {
               console.log("No existing schedules found for the selected date.");
            }


         let formData = new FormData();
         formData.append("date", this.sameDate); 
         formData.append("start", this.start); 
         formData.append("end", this.end); 
         formData.append("duration", this.duration);  
         formData.append("doctor_id", this.$route.params.id); 
         formData.append("session_id", this.session_id);
         formData.append("consultation_fee", this.fee);

         if(this.edit_id){
            formData.append("doctor_edit_id", this.edit_id); 
         }else{
            formData.append("doctor_edit_id", ''); 
         } 
         formData.append("token_type", this.reserved); 


         let url = "api/admin/leave/editSession2";

         this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            this.$axios
               .post(url, formData, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchData(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });

         },

         bookedConsultationSlots(){

         this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            if(this.type === 'clinic'){
               this.consultation_type = 3;
            }else if(this.type === 'home'){
               this.consultation_type = 2;
            }else{
               this.consultation_type = 1;
            }


            let url = "api/admin/leave/bookedSlotsDate?date=" + this.sameDate+ "&start=" + this.start + "&end=" + this.end + "&type=" + this.consultation_type + "&day_id=" + this.day + "&doctor_id=" + this.$route.params.id;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {

                     if (response.data.message) {
                        this.booked_slots = response.data.message;
                     }else{
                        this.booked_slots = 'No bookings for the schedule';
                     }
                     this.confirmEditSchedule(this.booked_slots);
     
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchData(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });

         },

         confirmEditSchedule(message) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm(message, {
                  title: 'Are you sure you want to edit the schedule!',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value =>{
                  this.deactivate = value
                  console.log(value);
                  if(this.deactivate){
                  this.editschedule =1;
                  this.leave_status ='';
                  this.title_modal = "Edit Session";
                  this.$refs['session-modal'].show();
                  }
               })
               .catch(err => {
                  console.log(err);
               })
         },



         confirmClinicLeave(type) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want clear?', {
                  title: 'Mark Leave?',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value =>{
                  this.deactivate = value
                  console.log(value);
                  if(this.deactivate){
                  this.editschedule ='';
                  this.removeSessions(type);
                  this.$refs['leave-modal'].hide();
                  }
               })
               .catch(err => {
                  console.log(err);
               })
         },

         confirmSessionLeave(obj, obj1,msg) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm(msg, {
                  title: 'Are you sure you want to clear the session!?',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value =>{
                  this.deactivate = value
                  console.log(value);
                  if(this.deactivate){
                  this.editschedule ='';
                  console.log(obj);
                  console.log(obj1);
                  this.removeDay(obj, obj1);
                  this.$refs['leave-modal'].hide();
                  }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         SetclearSession(session, schedule,type) {
           
            this.curr_session = session;
            this.curr_schedule = schedule;
            this.curr_type = type;
            this.handleFormSubmit('clear_session');
         },

         clearSessionSlots(session, schedule,type) {
            console.log(session);
            console.log(schedule);
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/leave/bookedSlotsDate?date=" + schedule.date+ "&start=" + session.start_time + "&end=" + session.end_time + "&type=" + type + "&day_id=" + schedule.dayId + "&doctor_id=" + this.$route.params.id;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {

                     if (response.data.message) {
                        this.booked_slots = response.data.message;
                     }else{
                        this.booked_slots = 'No bookings for the schedule';
                     }
                     this.confirmSessionLeave(session,schedule,this.booked_slots);
     
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchData(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });

           
         },

         editSession(obj, date, day_id, index, obj1, type) {
            // session, clinic_schedule.date, clinic_schedule.dayId, index, schedule_session, 'clinic'
            // alert(type);
            //console.log(obj);
            this.start = obj.start_time;
            this.end = obj.end_time;
            this.sameDate = date;
            this.day = day_id;
            this.type = type;
            this.duration = obj.duration;
            this.session_id = obj.doctor_session_id;
            this.edit_id = obj.doctor_edit_id;
            this.fee = obj1.consultation_fee;
            this.clinic_id = obj1.clinic_id;
            this.clinic_name = obj1.clinic_name;
            this.reserved = obj.token_type;
            this.index = index;
            this.edit = true;

            // this.bookedConsultationSlots()
            this.handleFormSubmit('edit_session');

           
         },

         getWeekDay(day) {
            let week_day;
            switch(day) {
               case 0: 
                  week_day = 'mon';
                  break;
               case 1: 
                  week_day = 'tue';
                  break;
               case 2: 
                  week_day = 'wed';
                  break;
               case 3: 
                  week_day = 'thu';
                  break;
               case 4: 
                  week_day = 'fri';
                  break;
               case 5: 
                  week_day = 'sat';
                  break;
               case 6: 
                  week_day = 'sun';
                  break;
               default:
                  week_day = '';
                  break;
            }
            return week_day;
         },

         handleFormSubmit(form_type) {
            this.showModal("pin-modal");
            this.form_type = form_type;
                  
         },

         checkPin() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/check_pin_no";

            let formData = new FormData();
            formData.append("pin_no", this.pin_no); 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     this.hideModal('pin-modal');
                     if(this.form_type == 'mark_leave'){
                        this.confirmLeave();
                     }else if(this.form_type == 'add_video_session'){
                        this.type = 'video';
                        this.showModal("session-modal");
                     }else if(this.form_type == 'add_home_session'){
                        this.type = 'home';
                        this.showModal("session-modal");
                     }else if(this.form_type == 'add_clinic_session'){
                        this.type = 'clinic';
                        this.showModal("session-modal");
                     }else if(this.form_type == 'video_clear'){
                        this.type = 'video';
                        this.confirmClinicLeave(this.type);
                     }else if(this.form_type == 'clinic_clear'){
                        this.type = 'clinic';
                        this.confirmClinicLeave(this.type);
                     }else if(this.form_type == 'home_clear'){
                        this.type = 'home';
                        this.confirmClinicLeave(this.type);
                     }else if(this.form_type == 'edit_session'){
                        this.bookedConsultationSlots();
                     } else if(this.form_type == 'clear_session'){  
                        this.clearSessionSlots(this.curr_session, this.curr_schedule,this.curr_type);
                     }      

                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");

                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },
         clearForm() {
            this.errors = {};
            this.pin_no = ''; 
            this.form_type = ''; 
         },

         clearSession() {
            this.start = '';
            this.end = '';
            this.day = null;
            this.type = '';
            this.duration_id = '';
            this.duration = '';
            this.fee = '';
            this.clinic_id = '';
            this.clinic_name = '';
            this.reserved = '';
            this.index = '';
            this.sameDate = '';
            this.title_modal = "Add Session";
            this.edit = false;
            this.errors = {};
            this.curr_session = {};
            this.curr_schedule = {};
            this.curr_type =  "";
         },
         checkDate(){
            if(this.schedule_date == this.schedule_from_date){
               this.eqDate = true;
               this.dfDate=false;
            }else{
               this.eqDate = false;
               this.dfDate=true;
            }
            this.leave_status= null;
            this.editschedule= '';
         },

         removeSession(obj, index) {
              obj.splice(index, 1);
         }, 


         removeSessions(type) {

         

         console.log(this.video_consultation);

         let formData = new FormData();
         formData.append("doctor_id", this.$route.params.id); 
         formData.append("from_date", this.schedule_from_date); 
         formData.append("to_date", this.schedule_date);   

         let url = "";

         this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            if (type == 'video') {
               url = "api/admin/leave/videoClear2";
               this.video_consultation = [];
            } else if (type == 'home') {
               url = "api/admin/leave/homeClear2";
               this.home_consultation = [];
            } else if (type == 'clinic') {
               url = "api/admin/leave/clinicClear2";
               this.clinic_consultation = [];
            }

            this.$axios
               .post(url, formData, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchData(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },

         removeDay(obj, obj1) {


            let formData = new FormData();
            formData.append("date", obj1.date); 
            formData.append("day_id", obj1.dayId); 
            formData.append("session_id", obj.doctor_session_id);
            if(obj.doctor_edit_id){
               formData.append("edit_id", obj.doctor_edit_id); 
            }else{
               formData.append("edit_id", ''); 
            }
            formData.append("doctor_id", this.$route.params.id); 


            let url = "api/admin/leave/clear2";

            this.getToken();
               const config = {
                  headers: {
                     "Content-type": "application/json",
                     "Accept": "application/json",
                     "Authorization": "Bearer " + this.token,
                  },
               };



            this.$axios
               .post(url, formData, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchData(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });


         },

         setClinicName() {
            this.clinic_name = event.target.options[event.target.options.selectedIndex].label;
            const selectedClinic = this.clinics.find(clinic => clinic.id === this.clinic_id);
            console.log(selectedClinic);
            if (selectedClinic) {
               this.fee = selectedClinic.consultation_fee; // Set the consultation fee based on the selected clinic
            } else {
               this.fee = ''; // Reset the fee if no clinic is selected
            }
         },

         markLeave() {
            this.leave_status = 1;
            this.edit_schedule ='';
            this.video_consultation = [];

            this.home_consultation = [];

            this.clinic_consultation = [];
         },

         unmarkLeave() {
            this.leave_status = null;
            this.edit_schedule ='';
            this.video_consultation = [];
            

            this.home_consultation = [];

            this.clinic_consultation = [];
         },
      }
   }
</script>

<style type="text/css">
   .schedules table td {
      padding: 10px;
   }

   .schedules table td .row {
      padding: 0;
   }

</style>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <router-link :to="{ name: 'doctors' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        
                     </div>
                  </div>
                  <!----- top button area ends----> 

                  <div class="row">
                     <div class="form-group col-md-4">
                        <label>From Date <span class="text-danger">*</span></label>
                        <input type="date" class="form-control" v-model="schedule_from_date" @change="fetchData()"/>
                     </div>  
                     <div class="form-group col-md-4">
                        <label>To Date <span class="text-danger">*</span></label>
                        <input type="date" class="form-control" v-model="schedule_date" @change="fetchData()" />
                     </div> 
                     <div class="col-md-4 d-flex align-items-center" v-if="schedule_date">
                           <!-- <b-button v-b-modal.session-modal variant="primary" v-if="dfDate" class="btn-sm" >Add Schedule</b-button> -->
                        <span class="ms-2">
                        <!-- <b-button v-if="leave_status==1" variant="danger" class="btn-sm" @click="unmarkLeave()">Unmark Leave</b-button> -->
                        <b-button  variant="danger" @click="handleFormSubmit('mark_leave')" class="btn-sm" >Mark as Leave</b-button>
                        </span>
                     </div>
                      
                  </div>
                          
                     <div v-if="leave_status==1"> Marked as leave</div>
                     <div v-if="editschedule==1"> Schedules updated</div>
      <div>
        
         <div v-if="schedule_from_date && schedule_date">
                        <!------ Video Consultation starts ----------> 
                        <b-card header-class="bg-transparent border-light" class="border border-light schedules" v-if="video_schedule_status">                         
                           <h5 class="card-title mb-4 bg-light p-2">
                              Video Consultation                           
                              
                           </h5>                      
                           <div class="row m-0" v-if="video_schedules.length">
                              <div v-for="(video_schedule, index) in video_schedules" :key="index">
                                 <div class="col-md-12" v-if="video_schedule.schedules.length">
                                    <label v-if="video_schedule.schedules.length">{{video_schedule.date | formatDate2 }}  <span v-if="video_schedule.dayId==1">Monday</span>
                                       <span v-if="video_schedule.dayId==2">Tuesday</span>
                                       <span v-if="video_schedule.dayId==3">Wednesday</span>
                                       <span v-if="video_schedule.dayId==4">Thursday</span>
                                       <span v-if="video_schedule.dayId==5">Friday</span>
                                       <span v-if="video_schedule.dayId==6">Saturday</span>
                                       <span v-if="video_schedule.dayId==7">Sunday</span>
                                    </label>
                                    <div class="">
                                       <div class="input-tag" v-for="(session, index) in video_schedule.schedules" :key="index">
                                          <!-- <p>{{ session.start_time| formatTime }} - {{ session.end_time | formatTime }} | {{session.duration}} min<span @click="clearSessionSlots(session, video_schedule, 1)" class="text-danger"><i class="fas fa-times-circle"></i></span><span @click="editSession(session, video_schedule.date, video_schedule.dayId, index, session, 'video')" class="text-primary"><i class="fas fa-edit" ></i></span></p> -->
                                          <p>{{ session.start_time| formatTime }} - {{ session.end_time | formatTime }} | {{session.duration}} min<span @click="SetclearSession(session, video_schedule, 1)" class="text-danger"><i class="fas fa-times-circle"></i></span><span @click="editSession(session, video_schedule.date, video_schedule.dayId, index, session, 'video')" class="text-primary"><i class="fas fa-edit" ></i></span></p>
                                       </div>
                                    </div><br>
                                 </div>
                              </div>
                              
                           </div>  

                           <div class="row m-0" v-else>  
                              <div class="col-12 p-0">
                                 <p>No video consultation sessions for this day</p>
                              </div>
                                           
                           </div>
                           <div class="col-md-12">
                                 <div class="float-end me-2">                    
                                    <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="type='video'">Add</b-button> -->
                                    <!-- <b-button  variant="danger" class="btn-sm ms-2"  @click="confirmClinicLeave(type='video')">Clear</b-button> -->
                                    <b-button  variant="success" class="btn-sm" @click="handleFormSubmit('add_video_session')" >Add</b-button>
                                    <b-button  variant="danger" class="btn-sm ms-2" @click="handleFormSubmit('video_clear')">Clear</b-button>

                                 </div> 
                              </div>         
                        </b-card>
                        <!------ Video Consultation ends ---------->                          
                        <!------ Home Consultation starts ----------> 
                        <b-card header-class="bg-transparent border-light" class="border border-light schedules" v-if="home_schedule_status">                         
                           <h5 class="card-title mb-4 bg-light p-2">
                              Home Consultation                           
                           </h5>                      
                           <div class="row m-0" v-if="home_schedules.length">
                              <div v-for="(home_schedule, index) in home_schedules" :key="index">
                                 <div class="col-md-12" v-if="home_schedule.schedules.length">
                                    <label v-if="home_schedule.schedules.length">{{home_schedule.date | formatDate2 }}  <span v-if="home_schedule.dayId==1">Monday</span>
                                       <span v-if="home_schedule.dayId==2">Tuesday</span>
                                       <span v-if="home_schedule.dayId==3">Wednesday</span>
                                       <span v-if="home_schedule.dayId==4">Thursday</span>
                                       <span v-if="home_schedule.dayId==5">Friday</span>
                                       <span v-if="home_schedule.dayId==6">Saturday</span>
                                       <span v-if="home_schedule.dayId==7">Sunday</span>
                                    </label>
                                    <div class="" v-if="home_schedule.schedules.length">
                                       <div class="input-tag" v-for="(session, index) in home_schedule.schedules" :key="index">
                                          <!-- <p>{{ session.start_time| formatTime }} - {{ session.end_time | formatTime }} | {{session.duration}} min<span @click="clearSessionSlots(session, home_schedule ,2)" class="text-danger"><i class="fas fa-times-circle"></i></span><span @click="editSession(session, home_schedule.date, home_schedule.dayId, index, session, 'home')" class="text-primary"><i class="fas fa-edit" ></i></span></p> -->
                                          <p>{{ session.start_time| formatTime }} - {{ session.end_time | formatTime }} | {{session.duration}} min<span @click="SetclearSession(session, home_schedule ,2)" class="text-danger"><i class="fas fa-times-circle"></i></span><span @click="editSession(session, home_schedule.date, home_schedule.dayId, index, session, 'home')" class="text-primary"><i class="fas fa-edit" ></i></span></p>
                                       </div>
                                    </div><br>
                                 </div>
                              </div>
                              
                           </div>  
                           <div class="row m-0" v-else>  
                              <div class="col-12 p-0">
                                 <p>No home consultation sessions for this day</p>
                              </div> 
                                         
                           </div>
                           <div class="col-md-12">
                           <div class="float-end me-2">                    
                              <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="type='home'">Add</b-button> -->
                              <!-- <b-button  variant="danger" class="btn-sm ms-2"  @click="confirmClinicLeave(type='home')">Clear</b-button> -->
                              <b-button  variant="success" class="btn-sm" @click="handleFormSubmit('add_home_session')" >Add</b-button>
                              <b-button  variant="danger" class="btn-sm ms-2"  @click="handleFormSubmit('home_clear')">Clear</b-button>

                           </div> 
                        </div>   
                        </b-card>
                        
                        <!------ Home Consultation ends ---------->

                        <!------ Clinic Consultation starts ----------> 
                        <b-card header-class="bg-transparent border-light" class="border border-light schedules clinic-schedules" >                         
                           <h5 class="card-title mb-4 bg-light p-2">
                               Clinic Consultation 
                           </h5> 
                           <ul class="reservervation-defs" v-if="clinic_schedules.length">
                              <li><i class="fas fa-square not-reserved-color"></i> Token Vending Machine Only</li>
                              <li><i class="fas fa-square reserved-color"></i> Both</li>
                           </ul>                      
                           <div class="row m-0" style="clear:both;" v-if="filteredClinicSchedules.length">
                                 <div v-for="(clinic_schedule, index) in filteredClinicSchedules" :key="index">
                                    <label v-if="clinic_schedule.schedules.length">
                                          {{ clinic_schedule.date | formatDate2 }}
                                          <span v-if="clinic_schedule.dayId == 1">Monday</span>
                                          <span v-if="clinic_schedule.dayId == 2">Tuesday</span>
                                          <span v-if="clinic_schedule.dayId == 3">Wednesday</span>
                                          <span v-if="clinic_schedule.dayId == 4">Thursday</span>
                                          <span v-if="clinic_schedule.dayId == 5">Friday</span>
                                          <span v-if="clinic_schedule.dayId == 6">Saturday</span>
                                          <span v-if="clinic_schedule.dayId == 7">Sunday</span>
                                    </label>

                           <div v-if="clinic_schedule.schedules.length">
                                 <div v-for="(schedule_session, index) in clinic_schedule.schedules" :key="index">
                                    <div class="input-tag" :class="{ 'reserved': session.token_type == 1, 'not-reserved': session.token_type == 2 }" v-for="(session, session_index) in schedule_session.sessions" :key="session_index">
                                       <p>
                                             {{ session.start_time | formatTime }} - {{ session.end_time | formatTime }} | {{ session.duration }} min
                                                <span @click="SetclearSession(session, clinic_schedule,3)" class="text-danger">
                                                   <i class="fas fa-times-circle"></i>
                                             </span>
                                             <span @click="editSession(session, clinic_schedule.date, clinic_schedule.dayId, index, schedule_session, 'clinic')" class="text-primary">
                                                <i class="fas fa-edit"></i>
                                             </span>
                                       </p>
                                       <p class="clinic-name">{{ schedule_session.clinic_name }} | Cons.Fee - {{ schedule_session.consultation_fee }}</p>
                                    </div>
                                 </div>
                           </div>
                        </div>
                     </div>
  
                           <div class="row" v-else>  
                                 <div class="col-md-12">
                                    <p>No clinic consultation sessions for this day</p>
                              </div>
                            
                           </div> 
                           <div class="col-md-12">
                                 <div class="float-end me-2">                    
                                          <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="type='clinic'">Add</b-button> -->
                                          <!-- <b-button  variant="danger" class="btn-sm ms-2"  @click="confirmClinicLeave(type='clinic')">Clear</b-button> -->
                                          <b-button  variant="success" class="btn-sm" @click="handleFormSubmit('add_clinic_session')" >Add</b-button>
                                          <b-button  variant="danger" class="btn-sm ms-2"  @click="handleFormSubmit('clinic_clear')">Clear</b-button>

                                 </div> 
                              </div>                
                        </b-card>
                        <div class="float-end">                    
               <!-- <b-button variant="primary" class="btn btn-primary float-end">Submit</b-button> -->
            </div>
                        <!------ Clinic Consultation ends ---------->
         </div>
        
                        
                  </div>
               </div>
            
            </div>
         </div>
         <!-- <div class="col-12">
            <div class="row">
                     <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
            <b-tab active>
            <template v-slot:title>
         
             <span class="">Upcoming Leaves</span>
            </template>
               <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                             
                              <div class="media-body">
                                 <h4><p class="text-muted fw-medium mb-2">10 July 2022</p></h4>
                                 <span class="mb-0">Time: 10.30 AM - 4:00 PM | 5 Min
                                 <b-button  variant="danger" class="btn-sm float-end ms-2" @click="unmarkLeave()">Unmark Leave</b-button>
                                    <span class="btn btn-outline-primary btn-sm float-end">Home Visit</span>
                                 </span>
                                 
                              </div>                              
                           </div>
               </b-card> 
               <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                             
                              <div class="media-body">
                                 <h4><p class="text-muted fw-medium mb-2">21 July 2022</p></h4>
                                 <span class="mb-0">Time: 11.30 AM - 2:00 PM | 5 Min | Aster Clinic
                                    <b-button  variant="danger" class="btn-sm float-end ms-2" @click="unmarkLeave()">Unmark Leave</b-button>
                                    <span class="btn btn-outline-primary btn-sm float-end">Clinic Visit</span>
                                 </span>
                                 
                              </div>                              
                           </div>
                  </b-card>       
            </b-tab>

            <b-tab>
         
               <template v-slot:title>
         
         <span class="">Leave History</span>
        </template>
           <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                       <div class="media">
                         
                          <div class="media-body">
                             <h4><p class="text-muted fw-medium mb-2">10 June 2022</p></h4>
                             <span class="mb-0">Time: 11.30 AM - 3:00 PM | 10 Min
                                <span class="btn btn-outline-primary btn-sm float-end">Home Visit</span>
                             </span>
                             
                          </div>                              
                       </div>
           </b-card> 
           <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                       <div class="media">
                         
                          <div class="media-body">
                             <h4><p class="text-muted fw-medium mb-2">8 June 2022</p></h4>
                             <span class="mb-0">Time: 11.30 AM - 2:00 PM | 5 Min | Aster Clinic
                                <span class="btn btn-outline-primary btn-sm float-end">Clinic Visit</span>
                             </span>
                             
                          </div>                              
                       </div>
              </b-card>  
                        
          
            </b-tab>
            
            </b-tabs>
               

                     </div>
         </div> -->
      </div>

         <!---- modal starts ---->
         <b-modal ref="session-modal" id="session-modal" :title="title_modal" hide-footer @hidden="clearSession()">
            <b-form>    
               <b-col md="12" class="form-group">
            <div v-if="dfDate && !edit">
                  <b-col md="12" class="form-group">
                     
                  <label class="control-label">From Date<span class="text-danger">*</span></label>
                  <!-- <b-form-timepicker v-model="start" locale="en" size="sm"></b-form-timepicker>   -->  
                  <b-form-input  v-model="startDate" disabled="disabled"></b-form-input>
               </b-col>
               <b-col md="12" class="form-group">
                  <label class="control-label">To Date<span class="text-danger">*</span></label>
                  <!-- <b-form-timepicker v-model="start" locale="en" size="sm"></b-form-timepicker>   -->  
                  <b-form-input type="date" v-model="endDate" disabled="disabled"></b-form-input>
               </b-col>
            </div>
            <div v-else>
               <b-col md="12" class="form-group">
                  <label class="control-label">Date<span class="text-danger">*</span></label>
                  <!-- <b-form-timepicker v-model="start" locale="en" size="sm"></b-form-timepicker>   -->  
                  <b-form-input type="date" v-model="sameDate" disabled="disabled"> </b-form-input>
               </b-col>
            </div>
                           <!-- <label class="control-label">Type <span class="text-danger">*</span></label>
                           <select class="form-control" v-model="type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                              <option value="">Select</option>
                              <option value="video">Video</option>
                              <option value="clinic">Clinic</option>
                              <option value="home">Home</option>
                           </select> -->
                        </b-col>
               <div class="form-group" v-if="type=='clinic'">
                  <label>Clinic <span class="text-danger">*</span></label>
                  <b-form-select v-model="clinic_id" class="form-control" @change="setClinicName" v-bind:class="{ 'is-invalid': Boolean(errors.clinic_id) }">
                     <option value="">Select</option>
                     <option v-for="(clinic) in clinics" :value="clinic.id" :key="clinic.id">{{ clinic.name }}</option>
                   </b-form-select>
                   <div v-for="(val, index) in errors.clinic_id" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p></div>
               </div>                    
               <div class="form-group" v-if="type=='clinic'&&clinic_id">
                  <label>Consultation Fee <span class="text-danger">*</span></label>
                  <b-form-input  v-model="fee" :disabled="Boolean(fee)"  v-bind:class="{ 'is-invalid': Boolean(errors.fee) }"></b-form-input>
                  <div v-for="(val, index) in errors.fee" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p></div>
               </div> 
               <b-col md="12" class="form-group">
                  <label class="control-label">Start Time<span class="text-danger">*</span></label>
                  <!-- <b-form-timepicker v-model="start" locale="en" size="sm"></b-form-timepicker>   -->  
                  <!-- <b-form-input v-model="start" type="time"></b-form-input> -->
                  <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="start" type="text" placeholder="HH:mm" v-bind:class="{ 'is-invalid': Boolean(errors.start_time) }" readonly></b-form-input>
                     <b-input-group-append><b-form-timepicker v-model="start" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                     <div v-for="(val, index) in errors.start_time" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p></div>
                  </b-input-group>
               </b-col>

               <b-col md="12" class="form-group">
                  <label class="control-label">End Time<span class="text-danger">*</span></label>
                  <!-- <b-form-timepicker v-model="end" locale="en" size="sm"></b-form-timepicker> -->
                  <!-- <b-form-input v-model="end" type="time"></b-form-input> -->
                  <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="end" type="text" placeholder="HH:mm" v-bind:class="{ 'is-invalid': Boolean(errors.end_time) }" readonly></b-form-input>
                     <b-input-group-append><b-form-timepicker v-model="end" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                     <div v-for="(val, index) in errors.end_time" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                  </b-input-group>
               </b-col>

               <b-col md="12" class="form-group">
                     <label>Consultation Duration <span class="text-danger">*</span></label>

                     <b-input-group class="mb-3">
                        <b-form-input id="example-input" @input="setTime()" v-model="duration" type="text" placeholder="HH:mm" readonly v-bind:class="{ 'is-invalid': Boolean(errors.duration) }"></b-form-input>
                        <b-input-group-append>
                           <b-form-timepicker v-model="duration" @input="setTime()" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker>
                        </b-input-group-append>
                        <div v-for="(val, index) in errors.duration" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
                     </b-input-group>                 
                     <span class="ms-1" v-if="time_name"> {{time_name}}</span>
                  </b-col>
               <b-col md="12" class="form-group" v-if="type=='clinic'">
                  <label>Reserved For <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="reserved" v-bind:class="{ 'is-invalid': Boolean(errors.reserved) }"> 
                     <option value="">Select </option>
                     <option value="1">Both </option>
                     <option value="2">Token Vending Machine</option>
                     <!-- <option value="2">Mobile App</option> -->
                  </select>
                  <div v-for="(val, index) in errors.reserved" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p></div>
               </b-col>
                        
               <b-col md="12">
                  <!-- <b-button  class="me-3" variant="primary" @click="confirmSchedule()">Save</b-button> -->
                  <b-button  class="me-3" variant="primary" @click="checkDuration()">Save</b-button>
                  <b-button class="" variant="light" @click="$bvModal.hide('session-modal')">Cancel</b-button>
               </b-col>

            </b-form>
         </b-modal>
         <!---- modal ends ----->
         <b-modal ref="leave-modal" id="leave-modal" title="Mark Leave" hide-footer @hidden="clearSession()">
            <b-form>    
               <b-col md="12" class="form-group">
                           <label class="control-label">Type <span class="text-danger">*</span></label>
                           <select class="form-control" v-model="type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                              <option value="">All</option>
                              <option value="video">Video</option>
                              <option value="clinic">Clinic</option>
                              <option value="home">Home</option>
                           </select>
               </b-col>
               <div class="form-group" v-if="type=='clinic'">
                  <label>Clinic <span class="text-danger">*</span></label>
                  <b-form-select v-model="clinic_id" class="form-control" @change="setClinicName">
                     <option value="">Select</option>
                     <option v-for="(clinic) in clinics" :value="clinic.id" :key="clinic.id">{{ clinic.name }}</option>
                  </b-form-select>
               </div>                    
               <b-col md="12">
                  <b-button  class="me-3" variant="primary" @click="confirmLeave()">Save</b-button>
                  <b-button class="" variant="light" @click="$bvModal.hide('leave-modal')">Cancel</b-button>
               </b-col>

            </b-form>
         </b-modal>

          <!---- modal starts ---->
       <b-modal ref="pin-modal" id="pin-modal" title="" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="checkPin()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">Pin Number<span class="text-danger">*</span></label>
                  <b-form-input v-model="pin_no" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.pin_no) }"></b-form-input>

                  <div v-for="(val, index) in errors.pin_no" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>  
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Submit</b-button>
                  <b-button class="" variant="light" @click="hideModal('pin-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
